import { Button, PromoBanner } from '@/common'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function DeclarantDetailsIncompleteBanner({ declarantId }: { declarantId: string }) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <PromoBanner
      title={t('common:declarantDetailsCta.title')}
      description={t('common:declarantDetailsCta.description')}
      action={
        <Button
          onClick={() => {
            navigate(`/cbam-reporting/${declarantId}/edit-declarant`)
          }}
        >
          {t('common:declarantDetailsCta.action')}
        </Button>
      }
    />
  )
}
